/**
 * @fileOverview Renders 2 bullet charts, one for the conversion rate and one
 * for the cost per metric
 */
import React, { Fragment } from 'react'
import BulletChartGroup from './BulletChartGroup'
import { numberFormatter } from 'Utils/Formatters'
import injectStyles from 'react-jss'

const styles = {
  badBar: {
    backgroundColor: '#DB5163',
  },
  badText: {
    color: '#DB5163',
  },
}

/**
 * @typedef BulletChartsForMetricProps
 * @property {number} totalMissions
 * @property {number} totalMissionsWithResults
 * @property {number} targetConversionRate
 * @property {number} conversionRate
 * @property {string} metricName
 * @property {number} targetCostPerMetric
 * @property {number} costPerMetric
 *
 * @param {BulletChartsForMetric} props
 */
const BulletChartsForMetric = props => {
  const {
    totalMissions,
    totalMissionsWithResults,
    targetConversionRate,
    conversionRate,
    metricName,
    targetCostPerMetric,
    costPerMetric,
    classes,
    currencySign,
  } = props

  var totalMissingResults = totalMissions - totalMissionsWithResults

  var note = !totalMissionsWithResults
    ? "There's no conversion data"
    : totalMissingResults > 0
    ? `Missing results for ${numberFormatter(totalMissingResults)}
            missions`.replace(/\s+/g, ' ')
    : undefined

  return (
    <Fragment>
      {targetConversionRate !== null ? (
        <BulletChartGroup
          note={note}
          targetValue={targetConversionRate}
          actualValue={conversionRate}
          title={metricName + ' CVR: Actuals vs Planned'}
          suffix={'%'}
          horizontalBarInnerClassName={
            // Having a lower CVR is bad here
            conversionRate < targetConversionRate ? classes.badBar : null
          }
          actualValueClassName={
            conversionRate < targetConversionRate ? classes.badText : null
          }
        />
      ) : null}
      {targetCostPerMetric !== null ? (
        <BulletChartGroup
          note={note}
          targetValue={targetCostPerMetric}
          actualValue={costPerMetric}
          title={'Cost per ' + metricName}
          suffix={currencySign}
          horizontalBarInnerClassName={
            // Having a higher CPS is bad here
            costPerMetric > targetCostPerMetric ? classes.badBar : null
          }
          actualValueClassName={
            costPerMetric > targetCostPerMetric ? classes.badText : null
          }
        />
      ) : null}
    </Fragment>
  )
}

export default injectStyles(styles)(BulletChartsForMetric)



// WEBPACK FOOTER //
// ./src/Components/Stats/BulletChartsForMetric/index.js